import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
    selectPriceFrom,
    selectPriceTo,
    setPriceFrom,
    setPriceTo,
    resetPriceFrom,
    resetPriceTo
} from '../filterSlice'
import Slider from '../base/Slider'
import { selectCurrency } from '../../currency/currencySlice'
import setPartsPrice from '../../../utils/parts/setPartsPrice'
import parts from '../../../utils/constants/parts'

const Price = () => {
    const priceFrom = useSelector(selectPriceFrom)
    const priceTo = useSelector(selectPriceTo)
    const currency = useSelector(selectCurrency)

    const partsWithCurrency = useMemo(() => setPartsPrice(parts, currency), [currency])
    const priceRange = partsWithCurrency.map((part) => Math.floor(part.price_src))

    const maxPrice = Math.max(...priceRange) + 1 // cause floor
    const minPrice = Math.min(...priceRange)

    return (
        <Slider
            name={'Цена, ₽'}
            min={minPrice}
            max={maxPrice}
            from={priceFrom > 0 ? priceFrom : minPrice}
            to={priceTo > 0 ? priceTo : maxPrice}
            actionResetFrom={resetPriceFrom}
            actionResetTo={resetPriceTo}
            actionFrom={setPriceFrom}
            actionTo={setPriceTo}
        />
    )
}

export default Price
